import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../globalComponents/loader/DPLoader';
import { useInviteUserDetails } from '../hooks/useInviteUserDetails';
import InviteUserForm from './PublicInviteUserForm';
import StatusMessageScreen from '../../../../core-components/theme/components/StatusMessageScreen';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function InviteUserFormContainer() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const inviteToken = searchParams.get('inviteToken') || '';
  const {
    inviteUserDetails,
    isInviteUserDetailsLoading,
    inviteUserDetailsError,
    inviteUserDetailsVerified,
    inviteUserDetailsMessage,
  } = useInviteUserDetails(inviteToken);

  if (!inviteToken) {
    return (
      <StatusMessageScreen
        type="negative"
        messageHeading={t('userManagement.publicInvite.invalidLinkHeading', 'Invalid Invitation Link')}
        messageBody={t('userManagement.publicInvite.invalidLinkBody', 'Please check your invitation URL and try again.')}
      />
    );
  }
  if (inviteUserDetailsVerified) {
    toast.success(inviteUserDetailsMessage || t('userManagement.publicInvite.invitationAlreadyVerified', 'Invitation already verified'));
    navigate('/Login', { replace: true });
  }

  if (isInviteUserDetailsLoading) return <Loader />;

  if (inviteUserDetailsError) {
    const errorMessage =
      (inviteUserDetailsError as any)?.message ||
      (inviteUserDetailsError as Error)?.message ||
      t('userManagement.publicInvite.failedLoadInvite', 'Failed to load invite details');

    return (
      <StatusMessageScreen
        type="negative"
        messageHeading={t('userManagement.publicInvite.errorLoadingHeading', 'Error Loading Invitation')}
        messageBody={errorMessage}
      />
    );
  }

  if (!inviteUserDetails) {
    return (
      <StatusMessageScreen
        type="negative"
        messageHeading={t('userManagement.publicInvite.noInviteHeading', 'No Invite Details Found')}
        messageBody={t('userManagement.publicInvite.noInviteBody', 'The invitation details could not be retrieved. Please contact support.')}
      />
    );
  }

  return (
    <InviteUserForm
      key={inviteToken}
      inviteToken={inviteToken}
      initialData={inviteUserDetails}
    />
  );
}
